import { render, staticRenderFns } from "./EventWrapper.vue?vue&type=template&id=c334236e&scoped=true"
import script from "./EventWrapper.vue?vue&type=script&lang=js"
export * from "./EventWrapper.vue?vue&type=script&lang=js"
import style0 from "./EventWrapper.vue?vue&type=style&index=0&id=c334236e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c334236e",
  null
  
)

export default component.exports